import { CellContext, ColumnDef, createColumnHelper } from '@tanstack/react-table';

import { AdaptiveTableCell } from '@components/common';

import { IPath } from '@interfaces/networkElements/networkElements';

const columnHelper = createColumnHelper<IPath>();

export const getColumns = (): ColumnDef<any>[] => [
	columnHelper.accessor('path', {
		header: 'Data model path',
		enableSorting: true,
		cell: ({ getValue }: CellContext<IPath, any>) => {
			return <AdaptiveTableCell text={getValue()}/>;
		},
	}),
];
